import { useMemo } from 'react';
import { manifest, content } from './manifest.generated';
import type { DocManifestEntry } from './types';

export interface UseDocResult {
  entry: DocManifestEntry | null;
  body: string | null;
}

/** Resolve a single doc by slug. Returns `{entry: null, body: null}` if missing. */
export function useDoc(slug: string | undefined): UseDocResult {
  return useMemo(() => {
    if (!slug) return { entry: null, body: null };
    const entry = manifest.find((d) => d.slug === slug) ?? null;
    const body = entry ? (content[slug] ?? null) : null;
    return { entry, body };
  }, [slug]);
}
